module.exports = __webpack_public_path__ + "img/grey-stroke.b0b024d3.png";